export default __webpack_public_path__ + "static/media/checked.8e55d2cd.svg";